import { Link } from "@inertiajs/react"
import { IconDevices } from "@tabler/icons-react"
import { AppShell } from "@/components/app-shell"
import { ChartAreaInteractive } from "@/components/chart-area-interactive"
import { DataTable } from "@/components/data-table"
import { DeviceSummaryCard } from "@/components/dashboard/device-summary-card"
import { SectionCards } from "@/components/section-cards"
import { Button } from "@/components/ui/button"
import { useIsMobileShell } from "@/hooks/use-is-mobile-shell"
import type { DeviceSummary } from "@/types/device"

import data from "./data.json"

interface DashboardProps {
  devices_summary?: DeviceSummary[]
}

export default function Dashboard({ devices_summary = [] }: DashboardProps) {
  const isMobile = useIsMobileShell()

  if (isMobile) {
    if (devices_summary.length === 0) {
      return (
        <AppShell title="Dashboard">
          <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
            <IconDevices className="size-12 text-muted-foreground" aria-hidden="true" />
            <h3 className="mt-4 text-lg font-semibold">No devices yet</h3>
            <p className="mt-1 text-sm text-muted-foreground">
              Add your first Tilt Hydrometer to start monitoring your brews.
            </p>
            <Button asChild className="mt-4">
              <Link href="/devices">Add a device</Link>
            </Button>
          </div>
        </AppShell>
      )
    }

    return (
      <AppShell title="Dashboard">
        <div className="px-4">
          <ul className="flex flex-col gap-3">
            {devices_summary.map((summary) => (
              <li key={summary.device.id}>
                <DeviceSummaryCard summary={summary} />
              </li>
            ))}
          </ul>
        </div>
      </AppShell>
    )
  }

  return (
    <AppShell title="Dashboard">
      <SectionCards />
      <div className="px-4 lg:px-6">
        <ChartAreaInteractive />
      </div>
      <DataTable data={data} />
    </AppShell>
  )
}
